<template>
  <div>
    <Nav />
    <div id="content">
      <div class="register">
        <div class="wrapper">
          <div class="inner">
            <div class="main">
              <div class="login">
                <h1 class="main-title">Login</h1>
                <sui-form autocomplete="off">
                  <div class="list">
                    <sui-form-field>
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                      />
                    </sui-form-field>
                    <sui-form-field>
                      <label>Password</label>
                      <div v-if="!passwordHidden">
                        <input
                          v-model="passwordText"
                          class="password-input"
                          type="text"
                          placeholder="Enter your password"
                        />
                        <i
                          class="las la-eye-slash eye-icon"
                          @click="hidePassword"
                        ></i>
                      </div>
                      <div v-if="passwordHidden">
                        <input
                          v-model="passwordText"
                          class="password-input"
                          type="password"
                          placeholder="Enter your password"
                        />
                        <i
                          class="las la-eye eye-icon"
                          @click="showPassword"
                        ></i>
                      </div>
                    </sui-form-field>
                    <div class="forgot-text">
                      <a class="link" href="/">Forgot your password?</a>
                    </div>
                    <div class="submit-button">
                      <button class="btn btn-blue" type="submit">Log in</button>
                      <div class="remark">
                        <p>
                          Don’t have an account?<a class="link" href="/"
                            >Register</a
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </sui-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Nav from "@/components/layouts/Nav";
import Footer from "@/components/layouts/Footer";
export default {
  name: "Login",
  components: {
    Nav,
    Footer,
  },
  props: {
    passwordText: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      passwordHidden: {
        default: false,
        type: Boolean,
      },
    };
  },
  methods: {
    hidePassword() {
      this.passwordHidden = true;
    },
    showPassword() {
      this.passwordHidden = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
@import "~@/assets/stylesheets/register";
.login {
  .field {
    .password-input {
      position: relative;
    }
    .eye-icon {
      color: #c2c2c2;
      cursor: pointer;
      font-size: 20px;
      margin-left: -2rem;
      margin-top: 15px;
      position: absolute;
    }
  }
  .forgot-text {
    .link {
      color: $blue-primary;
      /* stylelint-disable-next-line declaration-no-important */
      font-size: 12px !important;
      font-weight: 400;
      margin-top: -12px;
    }
  }
}

@media only screen and (max-width: 991px) {
  .login {
    .field {
      .eye-icon {
        font-size: 20px;
        margin-top: 15px;
        right: 15px;
      }
    }
  }
}
</style>
